import { Type } from '@sinclair/typebox';
export const AccountSchema = Type.Object({
    number: Type.Number(),
    name: Type.String(),
});
